<template>
  <div v-click-outside="closeToggle" class="filter">
    <span class="type" @click="toggle()">{{selectedType.name || '主题'}}</span>
    <img :src="showTypes ? icons.up : icons.down" alt="icons" @click="toggle()">
    <input type="text" class="enter" :placeholder="`请输入要查找的${selectedType.name || '主题'}`" @click="showTypes = false" v-model="keyword" @keyup.enter="search()">
    <img src="../assets/img/filter/search.svg" alt="" class="search" @click="search();showTypes = false">
    <div class="selects" v-if="showTypes && types.length > 0">
      <p class="option" v-for="(t, i) in types" :key="i" @click="select(t)">
        {{t.name}}
      </p>
    </div>
  </div>
</template>

<script>
import vClickOutside from 'v-click-outside';
import store from "@common/store";
import common from '../common/common';
import { initGlobalState } from "qiankun";

export default {
  name: "globalFilter",
  directives: {
    clickOutside: vClickOutside.directive
  },
  props: ['pageType'],
  watch: {
    $route: {
      handler: function(newer, older) {
        if (newer.path !== older.path) {
          this.reset();
        }
      }
    },
    keyword(to) {
      const ajaxData = {
        search_option: this.selectedType.code+'' || "",
        key_words: to || ""
      };
      // this.globals && this.globals(ajaxData);
      // this.$store.commit('setKeyWord', to)
      store.commit('setKeyWord', to)
    }
  },
  data() {
    return {
      icons: {
        down: require("../assets/img/filter/down.svg"),
        up: require("../assets/img/filter/up.svg")
      },
      showTypes: false,
      selectedType: {},
      types: [],
      globals: null,
      keyword: "",
      from: ''
    };
  },
  methods: {
    closeToggle() {
      this.showTypes = false;
    },
    toggle() {
      this.showTypes = !this.showTypes;
    },
    select(t) {
      this.selectedType = t;
      this.showTypes = false;
    },
    getData(d) {
      this.types = d.types;
      this.from = d.from;
      this.types.forEach(i => {
        if (i.selected) {
          this.selectedType = i;
        }
      });
      if (!this.selectedType.code) {
        this.selectedType = this.types[0];
      }

      this.globals = d["callback"];
    },
    search() {
      const initialState = {};
      const actions = initGlobalState(initialState);
      const ajaxData = {
        search_option: this.selectedType.code+'' || "",
        key_words: this.keyword || ""
      };
      console.log(ajaxData.search_option)
      if (!ajaxData.search_option) {
        this.$toast("请选择要搜索的类型");
        return;
      }
      this.globals && this.globals(ajaxData);

      actions.setGlobalState({ ajaxData });

      if(this.from == 'index'){
        common.jump('/filter?k='+this.keyword+'&t='+ajaxData.search_option+'&m='+this.pageType,true)
        // console.log(8877)
      }
    },
    reset() {
      // this.$store.commit('setKeyWord', '')
      store.commit('setKeyWord', '')
      this.types = [];
      this.selectedType = {};
      this.keyword = "";
      this.globals = null;
      this.showTypes = false;
    }
  },
  destroyed() {
    // this.$store.commit('setKeyWord', '')
    store.commit('setKeyWord', '')
  },
  created() {
    // this.$store.commit('setKeyWord', '')
    store.commit('setKeyWord', '')
  }
};
</script>

<style lang="less" scoped>
@import "../assets/css/global.less";

.filter {
  max-width: 560px;
  min-width: 320px;
  width: auto;
  height: 40px;
  border-radius: 100px;
  background-color: rgba(185, 195, 195, 0.2);
  padding: 0 20px;
  display: flex;
  align-items: center;
  margin-right: 30px;
  font-size: 14px;
  color: @sub;
  position: relative;
  .type {
    margin-right: 10px;
    // min-width: 42px;
    // text-align-last: justify;
    cursor: pointer;
    font-weight: bold;
  }
  img {
    cursor: pointer;
  }
  .enter {
    background-color: transparent;
    flex: 1;
    margin: 0 20px;
    &::placeholder {
      font-size: 14px;
      color: @dateColor;
      font-weight: bold;
    }
  }
  .selects {
    width: 90px;
    position: absolute;
    top: 50px;
    left: 0;
    border-radius: 4px;
    overflow: hidden;
    padding: 10px 0;
    background-color: rgba(5, 15, 15, 0.8);
    z-index: 1;
    .option {
      height: 40px;
      padding-left: 20px;
      color: #fff;
      font-size: 14px;
      line-height: 40px;
      cursor: pointer;
      &:hover {
        background-color: @green;
      }
    }
  }
}
</style>
